import _asyncToGenerator from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectWithoutProperties from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["autoconnect", "reconnect", "reconnect_interval", "max_reconnects"];
import _regeneratorRuntime from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Buffer } from 'buffer';
import { EventEmitter } from 'eventemitter3'; // node_modules/esbuild-plugin-polyfill-node/polyfills/buffer.js

var WebSocketBrowserImpl = /*#__PURE__*/function (_EventEmitter) {
  _inherits(WebSocketBrowserImpl, _EventEmitter);

  var _super = _createSuper(WebSocketBrowserImpl);

  /** Instantiate a WebSocket class
  * @constructor
  * @param {String} address - url to a websocket server
  * @param {(Object)} options - websocket options
  * @param {(String|Array)} protocols - a list of protocols
  * @return {WebSocketBrowserImpl} - returns a WebSocket instance
  */
  function WebSocketBrowserImpl(address, options, protocols) {
    var _this;

    _classCallCheck(this, WebSocketBrowserImpl);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "socket", void 0);

    _this.socket = new window.WebSocket(address, protocols);

    _this.socket.onopen = function () {
      return _this.emit("open");
    };

    _this.socket.onmessage = function (event) {
      return _this.emit("message", event.data);
    };

    _this.socket.onerror = function (error) {
      return _this.emit("error", error);
    };

    _this.socket.onclose = function (event) {
      _this.emit("close", event.code, event.reason);
    };

    return _this;
  }
  /**
  * Sends data through a websocket connection
  * @method
  * @param {(String|Object)} data - data to be sent via websocket
  * @param {Object} optionsOrCallback - ws options
  * @param {Function} callback - a callback called once the data is sent
  * @return {Undefined}
  */


  _createClass(WebSocketBrowserImpl, [{
    key: "send",
    value: function send(data, optionsOrCallback, callback) {
      var cb = callback || optionsOrCallback;

      try {
        this.socket.send(data);
        cb();
      } catch (error) {
        cb(error);
      }
    }
    /**
    * Closes an underlying socket
    * @method
    * @param {Number} code - status code explaining why the connection is being closed
    * @param {String} reason - a description why the connection is closing
    * @return {Undefined}
    * @throws {Error}
    */

  }, {
    key: "close",
    value: function close(code, reason) {
      this.socket.close(code, reason);
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(type, listener, options) {
      this.socket.addEventListener(type, listener, options);
    }
  }]);

  return WebSocketBrowserImpl;
}(EventEmitter);

function WebSocket(address, options) {
  return new WebSocketBrowserImpl(address, options);
} // src/lib/utils.ts


var DefaultDataPack = /*#__PURE__*/function () {
  function DefaultDataPack() {
    _classCallCheck(this, DefaultDataPack);
  }

  _createClass(DefaultDataPack, [{
    key: "encode",
    value: function encode(value) {
      return JSON.stringify(value);
    }
  }, {
    key: "decode",
    value: function decode(value) {
      return JSON.parse(value);
    }
  }]);

  return DefaultDataPack;
}(); // src/lib/client.ts


var CommonClient = /*#__PURE__*/function (_EventEmitter2) {
  _inherits(CommonClient, _EventEmitter2);

  var _super2 = _createSuper(CommonClient);

  /**
  * Instantiate a Client class.
  * @constructor
  * @param {webSocketFactory} webSocketFactory - factory method for WebSocket
  * @param {String} address - url to a websocket server
  * @param {Object} options - ws options object with reconnect parameters
  * @param {Function} generate_request_id - custom generation request Id
  * @param {DataPack} dataPack - data pack contains encoder and decoder
  * @return {CommonClient}
  */
  function CommonClient(webSocketFactory) {
    var _this2;

    var address = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ws://localhost:8080";

    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$autoconnect = _ref.autoconnect,
        autoconnect = _ref$autoconnect === void 0 ? true : _ref$autoconnect,
        _ref$reconnect = _ref.reconnect,
        reconnect = _ref$reconnect === void 0 ? true : _ref$reconnect,
        _ref$reconnect_interv = _ref.reconnect_interval,
        reconnect_interval = _ref$reconnect_interv === void 0 ? 1e3 : _ref$reconnect_interv,
        _ref$max_reconnects = _ref.max_reconnects,
        max_reconnects = _ref$max_reconnects === void 0 ? 5 : _ref$max_reconnects,
        rest_options = _objectWithoutProperties(_ref, _excluded);

    var generate_request_id = arguments.length > 3 ? arguments[3] : undefined;
    var dataPack = arguments.length > 4 ? arguments[4] : undefined;

    _classCallCheck(this, CommonClient);

    _this2 = _super2.call(this);

    _defineProperty(_assertThisInitialized(_this2), "address", void 0);

    _defineProperty(_assertThisInitialized(_this2), "rpc_id", void 0);

    _defineProperty(_assertThisInitialized(_this2), "queue", void 0);

    _defineProperty(_assertThisInitialized(_this2), "options", void 0);

    _defineProperty(_assertThisInitialized(_this2), "autoconnect", void 0);

    _defineProperty(_assertThisInitialized(_this2), "ready", void 0);

    _defineProperty(_assertThisInitialized(_this2), "reconnect", void 0);

    _defineProperty(_assertThisInitialized(_this2), "reconnect_timer_id", void 0);

    _defineProperty(_assertThisInitialized(_this2), "reconnect_interval", void 0);

    _defineProperty(_assertThisInitialized(_this2), "max_reconnects", void 0);

    _defineProperty(_assertThisInitialized(_this2), "rest_options", void 0);

    _defineProperty(_assertThisInitialized(_this2), "current_reconnects", void 0);

    _defineProperty(_assertThisInitialized(_this2), "generate_request_id", void 0);

    _defineProperty(_assertThisInitialized(_this2), "socket", void 0);

    _defineProperty(_assertThisInitialized(_this2), "webSocketFactory", void 0);

    _defineProperty(_assertThisInitialized(_this2), "dataPack", void 0);

    _this2.webSocketFactory = webSocketFactory;
    _this2.queue = {};
    _this2.rpc_id = 0;
    _this2.address = address;
    _this2.autoconnect = autoconnect;
    _this2.ready = false;
    _this2.reconnect = reconnect;
    _this2.reconnect_timer_id = void 0;
    _this2.reconnect_interval = reconnect_interval;
    _this2.max_reconnects = max_reconnects;
    _this2.rest_options = rest_options;
    _this2.current_reconnects = 0;

    _this2.generate_request_id = generate_request_id || function () {
      return ++_this2.rpc_id;
    };

    if (!dataPack) _this2.dataPack = new DefaultDataPack();else _this2.dataPack = dataPack;
    if (_this2.autoconnect) _this2._connect(_this2.address, _objectSpread({
      autoconnect: _this2.autoconnect,
      reconnect: _this2.reconnect,
      reconnect_interval: _this2.reconnect_interval,
      max_reconnects: _this2.max_reconnects
    }, _this2.rest_options));
    return _this2;
  }
  /**
  * Connects to a defined server if not connected already.
  * @method
  * @return {Undefined}
  */


  _createClass(CommonClient, [{
    key: "connect",
    value: function connect() {
      if (this.socket) return;

      this._connect(this.address, _objectSpread({
        autoconnect: this.autoconnect,
        reconnect: this.reconnect,
        reconnect_interval: this.reconnect_interval,
        max_reconnects: this.max_reconnects
      }, this.rest_options));
    }
    /**
    * Calls a registered RPC method on server.
    * @method
    * @param {String} method - RPC method name
    * @param {Object|Array} params - optional method parameters
    * @param {Number} timeout - RPC reply timeout value
    * @param {Object} ws_opts - options passed to ws
    * @return {Promise}
    */

  }, {
    key: "call",
    value: function call(method, params, timeout, ws_opts) {
      var _this3 = this;

      if (!ws_opts && "object" === typeof timeout) {
        ws_opts = timeout;
        timeout = null;
      }

      return new Promise(function (resolve, reject) {
        if (!_this3.ready) return reject(new Error("socket not ready"));

        var rpc_id = _this3.generate_request_id(method, params);

        var message = {
          jsonrpc: "2.0",
          method: method,
          params: params || void 0,
          id: rpc_id
        };

        _this3.socket.send(_this3.dataPack.encode(message), ws_opts, function (error) {
          if (error) return reject(error);
          _this3.queue[rpc_id] = {
            promise: [resolve, reject]
          };

          if (timeout) {
            _this3.queue[rpc_id].timeout = setTimeout(function () {
              delete _this3.queue[rpc_id];
              reject(new Error("reply timeout"));
            }, timeout);
          }
        });
      });
    }
    /**
    * Logins with the other side of the connection.
    * @method
    * @param {Object} params - Login credentials object
    * @return {Promise}
    */

  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        var resp;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.call("rpc.login", params);

              case 2:
                resp = _context.sent;

                if (resp) {
                  _context.next = 5;
                  break;
                }

                throw new Error("authentication failed");

              case 5:
                return _context.abrupt("return", resp);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function login(_x) {
        return _login.apply(this, arguments);
      }

      return login;
    }()
    /**
    * Fetches a list of client's methods registered on server.
    * @method
    * @return {Array}
    */

  }, {
    key: "listMethods",
    value: function () {
      var _listMethods = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.call("__listMethods");

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function listMethods() {
        return _listMethods.apply(this, arguments);
      }

      return listMethods;
    }()
    /**
    * Sends a JSON-RPC 2.0 notification to server.
    * @method
    * @param {String} method - RPC method name
    * @param {Object} params - optional method parameters
    * @return {Promise}
    */

  }, {
    key: "notify",
    value: function notify(method, params) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        if (!_this4.ready) return reject(new Error("socket not ready"));
        var message = {
          jsonrpc: "2.0",
          method: method,
          params: params
        };

        _this4.socket.send(_this4.dataPack.encode(message), function (error) {
          if (error) return reject(error);
          resolve();
        });
      });
    }
    /**
    * Subscribes for a defined event.
    * @method
    * @param {String|Array} event - event name
    * @return {Undefined}
    * @throws {Error}
    */

  }, {
    key: "subscribe",
    value: function () {
      var _subscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(event) {
        var result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (typeof event === "string") event = [event];
                _context3.next = 3;
                return this.call("rpc.on", event);

              case 3:
                result = _context3.sent;

                if (!(typeof event === "string" && result[event] !== "ok")) {
                  _context3.next = 6;
                  break;
                }

                throw new Error("Failed subscribing to an event '" + event + "' with: " + result[event]);

              case 6:
                return _context3.abrupt("return", result);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function subscribe(_x2) {
        return _subscribe.apply(this, arguments);
      }

      return subscribe;
    }()
    /**
    * Unsubscribes from a defined event.
    * @method
    * @param {String|Array} event - event name
    * @return {Undefined}
    * @throws {Error}
    */

  }, {
    key: "unsubscribe",
    value: function () {
      var _unsubscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(event) {
        var result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (typeof event === "string") event = [event];
                _context4.next = 3;
                return this.call("rpc.off", event);

              case 3:
                result = _context4.sent;

                if (!(typeof event === "string" && result[event] !== "ok")) {
                  _context4.next = 6;
                  break;
                }

                throw new Error("Failed unsubscribing from an event with: " + result);

              case 6:
                return _context4.abrupt("return", result);

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function unsubscribe(_x3) {
        return _unsubscribe.apply(this, arguments);
      }

      return unsubscribe;
    }()
    /**
    * Closes a WebSocket connection gracefully.
    * @method
    * @param {Number} code - socket close code
    * @param {String} data - optional data to be sent before closing
    * @return {Undefined}
    */

  }, {
    key: "close",
    value: function close(code, data) {
      this.socket.close(code || 1e3, data);
    }
    /**
    * Enable / disable automatic reconnection.
    * @method
    * @param {Boolean} reconnect - enable / disable reconnection
    * @return {Undefined}
    */

  }, {
    key: "setAutoReconnect",
    value: function setAutoReconnect(reconnect) {
      this.reconnect = reconnect;
    }
    /**
    * Set the interval between reconnection attempts.
    * @method
    * @param {Number} interval - reconnection interval in milliseconds
    * @return {Undefined}
    */

  }, {
    key: "setReconnectInterval",
    value: function setReconnectInterval(interval) {
      this.reconnect_interval = interval;
    }
    /**
    * Set the maximum number of reconnection attempts.
    * @method
    * @param {Number} max_reconnects - maximum reconnection attempts
    * @return {Undefined}
    */

  }, {
    key: "setMaxReconnects",
    value: function setMaxReconnects(max_reconnects) {
      this.max_reconnects = max_reconnects;
    }
    /**
    * Connection/Message handler.
    * @method
    * @private
    * @param {String} address - WebSocket API address
    * @param {Object} options - ws options object
    * @return {Undefined}
    */

  }, {
    key: "_connect",
    value: function _connect(address, options) {
      var _this5 = this;

      clearTimeout(this.reconnect_timer_id);
      this.socket = this.webSocketFactory(address, options);
      this.socket.addEventListener("open", function () {
        _this5.ready = true;

        _this5.emit("open");

        _this5.current_reconnects = 0;
      });
      this.socket.addEventListener("message", function (_ref2) {
        var message = _ref2.data;
        if (message instanceof ArrayBuffer) message = Buffer.from(message).toString();

        try {
          message = _this5.dataPack.decode(message);
        } catch (error) {
          return;
        }

        if (message.notification && _this5.listeners(message.notification).length) {
          if (!Object.keys(message.params).length) return _this5.emit(message.notification);
          var args = [message.notification];
          if (message.params.constructor === Object) args.push(message.params);else for (var i = 0; i < message.params.length; i++) {
            args.push(message.params[i]);
          }
          return Promise.resolve().then(function () {
            _this5.emit.apply(_this5, args);
          });
        }

        if (!_this5.queue[message.id]) {
          if (message.method) {
            return Promise.resolve().then(function () {
              var _message;

              _this5.emit(message.method, (_message = message) === null || _message === void 0 ? void 0 : _message.params);
            });
          }

          return;
        }

        if ("error" in message === "result" in message) _this5.queue[message.id].promise[1](new Error('Server response malformed. Response must include either "result" or "error", but not both.'));
        if (_this5.queue[message.id].timeout) clearTimeout(_this5.queue[message.id].timeout);
        if (message.error) _this5.queue[message.id].promise[1](message.error);else _this5.queue[message.id].promise[0](message.result);
        delete _this5.queue[message.id];
      });
      this.socket.addEventListener("error", function (error) {
        return _this5.emit("error", error);
      });
      this.socket.addEventListener("close", function (_ref3) {
        var code = _ref3.code,
            reason = _ref3.reason;
        if (_this5.ready) setTimeout(function () {
          return _this5.emit("close", code, reason);
        }, 0);
        _this5.ready = false;
        _this5.socket = void 0;
        if (code === 1e3) return;
        _this5.current_reconnects++;
        if (_this5.reconnect && (_this5.max_reconnects > _this5.current_reconnects || _this5.max_reconnects === 0)) _this5.reconnect_timer_id = setTimeout(function () {
          return _this5._connect(address, options);
        }, _this5.reconnect_interval);
      });
    }
  }]);

  return CommonClient;
}(EventEmitter); // src/index.browser.ts


var Client = /*#__PURE__*/function (_CommonClient) {
  _inherits(Client, _CommonClient);

  var _super3 = _createSuper(Client);

  function Client() {
    var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "ws://localhost:8080";

    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref4$autoconnect = _ref4.autoconnect,
        autoconnect = _ref4$autoconnect === void 0 ? true : _ref4$autoconnect,
        _ref4$reconnect = _ref4.reconnect,
        reconnect = _ref4$reconnect === void 0 ? true : _ref4$reconnect,
        _ref4$reconnect_inter = _ref4.reconnect_interval,
        reconnect_interval = _ref4$reconnect_inter === void 0 ? 1e3 : _ref4$reconnect_inter,
        _ref4$max_reconnects = _ref4.max_reconnects,
        max_reconnects = _ref4$max_reconnects === void 0 ? 5 : _ref4$max_reconnects;

    var generate_request_id = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, Client);

    return _super3.call(this, WebSocket, address, {
      autoconnect: autoconnect,
      reconnect: reconnect,
      reconnect_interval: reconnect_interval,
      max_reconnects: max_reconnects
    }, generate_request_id);
  }

  return Client;
}(CommonClient);

export { Client, CommonClient, DefaultDataPack, WebSocket };